import styled from 'styled-components'

import { mediaIpad, mediaIpadmini, mediaMobile } from './desktop'

export const Vrcomponents = styled.div`
    padding: 30px 50px;
  ${mediaMobile.Mobile`
    padding: 30px 10px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`
export const VrHeadercomponents = styled.div`
    background: #fff;
    padding: 40px 80px;
    min-height: 280px;
    border-radius: 30px;
  ${mediaMobile.Mobile`
    padding: 40px 20px;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const VrRowcomponents = styled.div`
    display: flex;
    margin-bootom: -30px;
  ${mediaMobile.Mobile`
    flex-direction: column;
    margin-bootom: unset;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const VrTextcomponents = styled.div`
    font-size: 40px;
    font-weight: bold;
    margin-right: 20px;
  ${mediaMobile.Mobile`
    margin-bottom: 20px;
    margin-right: unset;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const VrSearchcomponents = styled.div`
    margin-top: 15px;
  ${mediaMobile.Mobile`
    margin-bottom: 20px;
    margin-top: unset;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`



// WEBPACK FOOTER //
// ./src/components/styled-components/vrStyled.js